export default {
  methods: {
    removeNullFromObject(payload) {
      Object.keys(payload).forEach(
        (key) => payload[key] == null && delete payload[key]
      )
    }
  }
}
